// todo: upgrade category names
export const SC_CATEGORY_IDS = {
  Sonderartikel: "Sonderartikel",
  news_and_sales: "Neuprodukte_und_Sonderaktionen",
  offers: "Neuprodukte_und_Sonderaktionen",
  new_products: "Neuprodukte"
};
